import React from 'react';
import SEO from "../components/SEO/SEO";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <>
            <SEO title="404 - Pagina non trovata" description="La pagina che stai cercando non esiste." />
                <div style={{ flex:0.7, display:'flex', alignItems:'center' }}>
                    <div style={{display:'flex', flexDirection:'column', alignItems:'center', width:'100%'}}>
                    <h1>404 - Pagina non trovata</h1>
                    <p>La pagina che stai cercando non esiste.</p>
                    <Link to="/" style={{ textDecoration: 'none', color: '#CC0000' }}>
                        Torna alla Home
                    </Link>
                    </div>
                </div>
        </>
    );
};

export default NotFound;
